import { Injectable } from '@angular/core';

import { ApiService } from './api.service';
import { CONSTANTS } from '../../constants';

@Injectable({
    providedIn: 'root'
})

export class ConfigService extends ApiService {

    public getAuthConfigs(data: any) {
        return this.getQueryParams(CONSTANTS.API.CONFIG_DATA.GET_AUTH_CDS, data);
    }
    public updateCDatas(data: any) {
        return this.post(CONSTANTS.API.CONFIG_DATA.UPDATE_CDS, data);
    }
    public getConfigData(data: any) {
        return this.getQueryParams(CONSTANTS.API.CONFIG_DATA.GET_CDS, data);
    }
}
